import { render, staticRenderFns } from "./NewClassificators.vue?vue&type=template&id=1b9205b8"
import script from "./NewClassificators.vue?vue&type=script&lang=js"
export * from "./NewClassificators.vue?vue&type=script&lang=js"
import style0 from "./NewClassificators.vue?vue&type=style&index=0&id=1b9205b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports